import { call, takeLeading, select, put } from 'redux-saga/effects';
import {
  UPDATE_RECURRING_TASK_REQUEST,
  updateRecurringTaskFailureAction,
  UpdateRecurringTaskRequestAction,
  updateRecurringTaskSuccessAction,
} from '../actions';
import { enqueueNotification } from 'store/modules/ui';
import { makeTaskManagementApi } from 'services/TaskManagementApi/TaskManagementApi';
import { ITaskReminder } from 'services/TaskManagementApi/types/TaskManagementResponse';
import { RECURRING_TASKS_PATH } from 'containers/TaskManagement/RecurringTasks/recurrence';
import { duplicatedReminderIdsSelector, listTaskRemindersSelector } from '../selectors';
import { getRecurrenceError, notifyRecurringTaskSaveError, recurringTaskFormToRequest } from './createRecurringTaskSaga';

// OWA-11997. PUT v1/recurring-tasks/{taskId} with the whole form, the same body as create.
export function* updateRecurringTaskSaga(action: UpdateRecurringTaskRequestAction) {
  try {
    const duplicatedReminders = yield select(duplicatedReminderIdsSelector);
    if (duplicatedReminders?.length) {
      yield put(updateRecurringTaskFailureAction('Check duplicated reminders'));
      return;
    }

    const taskReminders: ITaskReminder[] = yield select(listTaskRemindersSelector);
    const recurringTaskToUpdate = recurringTaskFormToRequest(action.task, taskReminders);

    const taskManagementApi = makeTaskManagementApi();
    yield call(taskManagementApi.updateRecurringTask, action.taskId, recurringTaskToUpdate);
    yield put(updateRecurringTaskSuccessAction());
    yield put(enqueueNotification({ message: 'Task updated successfully', options: { variant: 'success' } }));
    yield call(action.history.push, RECURRING_TASKS_PATH);
  } catch (e) {
    const recurrenceError = getRecurrenceError(e);
    yield put(updateRecurringTaskFailureAction(e, recurrenceError));
    if (!recurrenceError) {
      yield* notifyRecurringTaskSaveError(e, 'Error updating recurring task');
    }
  }
}

// takeLeading for the same reason as create: a second Save must not PUT again.
export function* watchUpdateRecurringTaskSaga() {
  yield takeLeading([UPDATE_RECURRING_TASK_REQUEST], updateRecurringTaskSaga);
}
